import { useEffect, useState } from "react";
import UserIcon from "@surgia/ui/icons/popup/user.svg";
import MailIcon from "@surgia/ui/icons/popup/email.svg";
import PhoneIcon from "@surgia/ui/icons/popup/phone.svg";
import { apiClient } from "@surgia/api/src/client";
import { useTranslation } from "react-i18next";

const TenantInfoCard: React.FC<{ requestId: string | undefined }> = ({
  requestId,
}) => {
  const { t } = useTranslation();
  const [requestDetails, setRequestDetails] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const Spinner = () => (
    <div
      className="h-8 w-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"
      role="status"
      aria-label="Loading"
    />
  );

  useEffect(() => {
    if (!requestId) return;
    setLoading(true);
    (async () => {
      try {
        const response = await apiClient.get("/corporate/v1/request", {
          params: { id: requestId },
        });
        setRequestDetails(response.data[0]);
      } catch {
        setRequestDetails(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [requestId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Spinner />
      </div>
    );
  }
  // if (!requestDetails) return <div>No data found.</div>;

  return (
    <div className="p-4">
      <div className="flex justify-between items-start mb-2 ">
        <span className="text-xl font-bold text-gray-900">
          {requestDetails?.name}
        </span>
        <span className="text-base page-subtitle">
          {requestDetails?.type &&
            t(`shared.entityType.${requestDetails.type}`)}
        </span>
      </div>

      <div className="text-[#535862] text-base space-y-1 mb-4 text-[14px] font-[300]  ">
        {/* <div>
          {requestDetails?.full_address ?? "N/A (currently no address to show)"}
        </div> */}
        <div>{requestDetails?.city?.name ?? "N/A"}</div>
        {/* <div>{`${t("postalCode")}: 13322 (temporarily static )`}</div> */}
        {/* <div>{`${t("additionalNumber")}: 1234 (temporarily static )`}</div> */}
        <div>{requestDetails?.country?.name}</div>      </div>
      <div className="font-semibold text-[#414651] mb-1 text-[14px] font-normal">
        {t("contactPerson")}
      </div>
      <div className="text-[#535862] text-base space-y-1 text-[14px] font-[300] ">
        <div className="flex items-center gap-2">
          <img src={UserIcon} alt="User" />
          {requestDetails?.contact_person_first_name}{" "}
          {requestDetails?.contact_person_last_name}
        </div>
        <div className="flex items-center gap-2">
          <img src={MailIcon} alt="Mail" />
          {requestDetails?.contact_person_email}
        </div>
        <div className="flex items-center gap-2">
          <img src={PhoneIcon} alt="Phone" />
          {requestDetails?.contact_person_mobile}
        </div>
      </div>
    </div>
  );
};

export default TenantInfoCard;
